import {
  resetJobTitle,
  updateToolsWithPerson,
  updateGradesWithPerson,
  updatePeopleWithSchool,
  updateDepartmentsWithPerson
} from './stateUpdateHelpers.js';

import {toolLabels} from "./db.js";

export function selectSchool(state, schoolId) {
  const newState = updatePeopleWithSchool(state, schoolId);

  return {
    ...newState,
    schools: {
      ...newState.schools,
      selected: schoolId || null
    }
  };
}

export function selectPerson(state, personId) {
  const newState1 = updateToolsWithPerson(state, personId);
  const newState2 = updateDepartmentsWithPerson(newState1, personId);
  const newState3 = updateGradesWithPerson(newState2, personId);
  const newState = resetJobTitle(newState3);

  return {
    ...newState,
    people: {
      ...newState.people,
      selected: personId || null
    }
  };
}

export function selectTool(state, toolId) {
  return {
    ...state,
    tools: {
      ...state.tools,
      selected: toolId || null,
      selectedLabel: toolLabels[toolId]
    }
  };
}

export function selectDepartment(state, departmentId) {
  return {
    ...state,
    departments: {
      ...state.departments,
      selected: departmentId || null
    }
  };
}

export function selectGrade(state, gradeId) {
  return {
    ...state,
    grades: {
      ...state.grades,
      selected: gradeId || null
    }
  };
}

export function inputJobTitle(state, jobTitle) {
  return {
    ...state,
    jobTitle: jobTitle || null
  };
}
